import * as React from "react";
import { cn } from "@/lib/utils";

export interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  dividerClassName?: string;
}

const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  ({ className, dividerClassName, ...props }, ref) => {
    const Comp = "div";

    return (
      <Comp className={className} ref={ref} {...props}>
        <div className={cn("bg-neutral-300 h-px", dividerClassName)}></div>
      </Comp>
    );
  }
);

Divider.displayName = "Divider";

export { Divider };
